import React, { useEffect, useState } from "react";
import axios from "axios";
import { Accordion, Card, Badge } from "react-bootstrap";
import { AmbikaVenderApi } from "./config";
import { FaTruck } from "react-icons/fa";
import { GoPackage } from "react-icons/go";

const LoadedItemSummary = () => {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("ambikaDriverToken");
  const driverId = localStorage.getItem("ambikaDriverId");

  useEffect(() => {
    axios
      .post(
        `${AmbikaVenderApi}/driver/truckLoadedSummary`,
        { UserId: driverId },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(({ data }) => {
        if (data.success) setRoutes(data.data);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [driverId, token]);

  const getProductAttributes = (product) => {
    const attributes = [];

    if (product.size_name)
      attributes.push({ key: "Weight", value: product.size_name });

    if (product.shap_option)
      attributes.push({ key: "Shape", value: product.shap_option });

    if (typeof product.eggless !== "undefined")
      attributes.push({
        key: "Eggless",
        value: product.eggless ? (
          <Badge bg="success">Yes</Badge>
        ) : (
          <Badge bg="secondary">No</Badge>
        ),
      });

    if (typeof product.less_cream !== "undefined")
      attributes.push({
        key: "Less Cream",
        value: product.less_cream ? (
          <Badge bg="success">Yes</Badge>
        ) : (
          <Badge bg="secondary">No</Badge>
        ),
      });

    if (product.message_option)
      attributes.push({
        key: "Message on the Cake",
        value: product.message_option,
      });

    return attributes;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (routes.length === 0) {
    return (
      <div className="text-center py-5">
        <h5 className="text-muted">No loaded items found</h5>
      </div>
    );
  }

  return (
    <div className="min-vh-100 bg-light p-3 p-md-4">
      <div className="container-fluid container-lg">
        <h1 className="h3 h1-md fw-bold text-success mb-3 mb-md-4 d-flex align-items-center">
          Loaded Items Summary
        </h1>

        <Accordion className="mb-4" alwaysOpen>
          {routes.map((route, routeIdx) => (
            <Accordion.Item
              key={route.route_id}
              eventKey={`${routeIdx}`}
              className="mb-3"
            >
              <Accordion.Header className="bg-light">
                <div className="d-flex flex-column flex-md-row w-100 align-items-md-center gap-2">
                  <div className="d-flex align-items-center fs-5 fw-semibold">
                    <FaTruck
                      className="me-2 text-success flex-shrink-0"
                      size={20}
                    />
                    <span className="" style={{ minWidth: 0 }}>
                      {route.route_name}
                    </span>
                  </div>
                  <div className="text-muted ms-md-auto small text-nowrap">
                    Vehicle: {route.vehicle_no}
                  </div>
                </div>
              </Accordion.Header>

              <Accordion.Body className="p-0">
                <div className="p-2 p-md-3">
                  {route.order_detail.map((order, orderIdx) => (
                    <Card key={order.orderId} className="mb-3 border">
                      <Card.Header className="bg-success bg-opacity-10 border-bottom d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center py-2">
                        <div className="d-flex align-items-center mb-2 mb-md-0">
                          <GoPackage
                            className="me-2 text-success flex-shrink-0"
                            size={16}
                          />
                          <span className="fw-semibold text-truncate">
                            Order #{order.orderNo.split("/").pop()}
                          </span>
                        </div>
                        <Badge
                          bg="success"
                          className="bg-opacity-25 text-success"
                        >
                          {order.product_detail.length} item(s)
                        </Badge>
                      </Card.Header>

                      <Card.Body className="p-0">
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-2 g-md-3 p-2 p-md-3">
                          {order.product_detail.map((prod, pIdx) => (
                            <div
                              key={`${prod.orderProduct_id}-${pIdx}`}
                              className="col"
                            >
                              <div className="bg-danger bg-opacity-10 p-2 p-md-3 rounded border border-danger border-opacity-25 h-100">
                                <div className="d-flex justify-content-between mb-2">
                                  <h6 className="fw-semibold text-danger mb-0 text-truncate">
                                    {prod.productName}
                                  </h6>
                                  <Badge
                                    bg="light"
                                    text="dark"
                                    className="ms-2 flex-shrink-0"
                                  >
                                    {prod.quantity || 1} Pcs
                                  </Badge>
                                </div>

                                <div className="small">
                                  {getProductAttributes(prod).map(
                                    (attr, idx) => (
                                      <div
                                        key={idx}
                                        className="d-flex justify-content-between mb-1"
                                      >
                                        <span className="text-muted fw-medium">
                                          {attr.key}:
                                        </span>
                                        <span className="text-truncate ms-2 text-end">
                                          {attr.value}
                                        </span>
                                      </div>
                                    )
                                  )}
                                </div>

                                {prod.variants && prod.variants.length > 0 && (
                                  <div className="mt-2 mt-md-3 pt-2 pt-md-3 border-top border-danger border-opacity-25">
                                    <p className="small text-muted fw-medium mb-1 mb-md-2">
                                      Variants
                                    </p>
                                    {prod.variants.map((variant, vIdx) => (
                                      <div
                                        key={`variant-${vIdx}`}
                                        className="mb-2 mb-md-3"
                                      >
                                        <p className="small fw-medium mb-1 text-truncate">
                                          {variant.name}
                                        </p>
                                        <div className="small">
                                          {variant.options.map(
                                            (opt, optIdx) => (
                                              <div
                                                key={optIdx}
                                                className="d-flex justify-content-between mb-1"
                                              >
                                                <span className="text-muted">
                                                  {opt.key}:
                                                </span>
                                                <span className="text-truncate ms-2 text-end">
                                                  {opt.value}
                                                </span>
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default LoadedItemSummary;
